import { render, staticRenderFns } from "./LinkButtonBlock.vue?vue&type=template&id=69018e0c&scoped=true&"
import script from "./LinkButtonBlock.vue?vue&type=script&lang=js&"
export * from "./LinkButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./LinkButtonBlock.vue?vue&type=style&index=0&id=69018e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69018e0c",
  null
  
)

export default component.exports